module.exports = "<div *ngIf=\"context\">\r\n  <div *ngFor=\"let tool of tools\" class=\"toolSection\">\r\n    <mat-checkbox\r\n      [ngModel]=\"verifyIfContextToolExist(tool.id)\"\r\n      (change)=\"handleToolChange($event, tool)\">\r\n      {{tool.title || tool.name}}\r\n    </mat-checkbox>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/context/context-tools/context-tools.component.html
// module id = 976
// module chunks = 0